/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  COLOR_COMMAND,
  HIGHLIGHT_COMMAND,
  FONT_FAMILY_COMMAND,
  FONT_SIZE_COMMAND,
  handleColorCommand,
  handleHighlightCommand,
  handleFontFamilyCommand,
  handleFontSizeCommand,
} from './StyledTextCommands';

/**
 * Unified plugin for all text styling (color, highlight, font family, font size)
 * Replaces ColorPlugin, HighlightPlugin, FontFamilyPlugin, and FontSizePlugin
 */
const StyledTextPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const removeColorCommand = editor.registerCommand(
      COLOR_COMMAND,
      (payload) => {
        let success = false;
        editor.update(() => {
          if (payload === 'remove') {
            success = handleColorCommand(null);
          } else if (typeof payload === 'string') {
            success = handleColorCommand(payload);
          }
        });

        return true;
      },
      1 // COMMAND_PRIORITY_LOW
    );

    const removeHighlightCommand = editor.registerCommand(
      HIGHLIGHT_COMMAND,
      (payload) => {
        let success = false;
        editor.update(() => {
          if (payload === 'remove') {
            success = handleHighlightCommand(null);
          } else if (typeof payload === 'string') {
            success = handleHighlightCommand(payload);
          }
        });

        return true;
      },
      1
    );

    const removeFontFamilyCommand = editor.registerCommand(
      FONT_FAMILY_COMMAND,
      (payload) => {
        let success = false;
        editor.update(() => {
          if (payload === 'remove') {
            success = handleFontFamilyCommand(null);
          } else if (typeof payload === 'string') {
            success = handleFontFamilyCommand(payload);
          }
        });

        return true;
      },
      1
    );

    const removeFontSizeCommand = editor.registerCommand(
      FONT_SIZE_COMMAND,
      (payload) => {
        let success = false;
        editor.update(() => {
          if (payload === 'remove') {
            success = handleFontSizeCommand(null);
          } else if (typeof payload === 'string') {
            success = handleFontSizeCommand(payload);
          }
        });

        return true;
      },
      1
    );

    // Cleanup function
    return () => {
      removeColorCommand();
      removeHighlightCommand();
      removeFontFamilyCommand();
      removeFontSizeCommand();
    };
  }, [editor]);

  return null;
};

export default StyledTextPlugin;
